/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {EntitlementTransferContext} from '../models/EntitlementTransferContext';
import type {Error} from '../models/Error';
import type {Relation} from '../models/Relation';

export interface ExportEntitlements$Request {
    relation: Array<Relation>;
}

export interface ExportEntitlements$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const exportEntitlementsRequest = createAction<PayloadData<void, ExportEntitlements$Request>>('ENTITLEMENT_EXPORT__EXPORT_ENTITLEMENTS__REQUEST');
export const exportEntitlementsSuccess = createAction<PayloadData<EntitlementTransferContext, ExportEntitlements$Request>>('ENTITLEMENT_EXPORT__EXPORT_ENTITLEMENTS__SUCCESS');
export const exportEntitlementsFailure = createAction<PayloadData<Error, ExportEntitlements$Request, true>>('ENTITLEMENT_EXPORT__EXPORT_ENTITLEMENTS__FAILURE');

export const exportEntitlementsActions = [
    exportEntitlementsRequest,
    exportEntitlementsSuccess,
    exportEntitlementsFailure
] as const;

/**
 * @param {Array<Relation>} meta.relation
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const exportEntitlements = (meta: ExportEntitlements$Request, config?: ExportEntitlements$Config) => {
    return {
        CALL_API: {
            types: exportEntitlementsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/entitlements/export`,
            TRANSPORT_REQUEST_BODY: meta.relation,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

